// Bunny.net Configuration
// Replace these values with your actual bunny.net credentials and settings

export const BUNNY_NET_CONFIG = {
  // Your bunny.net library ID
  LIBRARY_ID: '459446',
  
  // Your bunny.net API key (if needed for direct video access)
  API_KEY: 'f68e62c3-4f17-4949-a775-00a016048cb782468f40-5041-4182-ac54-dce55fe8137e',
  
  // Base URL for bunny.net video delivery
  BASE_URL: 'https://iframe.mediadelivery.net/embed',
  
  // Direct video URL format (if using direct video access)
  DIRECT_VIDEO_URL: 'https://video.bunnycdn.com/stream',
  
  // Video quality settings
  QUALITY: {
    AUTO: 'auto',
    HD: '1080p',
    SD: '720p',
    LOW: '480p'
  },
  
  // Player settings
  PLAYER_SETTINGS: {
    autoplay: false,
    muted: false,
    controls: true,
    loop: false,
    preload: 'metadata'
  }
};

// Helper function to generate bunny.net embed URL
export const getBunnyNetEmbedUrl = (videoId: string, libraryId?: string) => {
  const libId = libraryId || BUNNY_NET_CONFIG.LIBRARY_ID;
  return `${BUNNY_NET_CONFIG.BASE_URL}/${libId}/${videoId}`;
};

// Helper function to generate direct video URL
export const getBunnyNetDirectUrl = (videoId: string, libraryId?: string) => {
  const libId = libraryId || BUNNY_NET_CONFIG.LIBRARY_ID;
  return `${BUNNY_NET_CONFIG.DIRECT_VIDEO_URL}/${libId}/${videoId}/play.mp4`;
}; 